import { render, staticRenderFns } from "./status-icon.vue?vue&type=template&id=f758a488&scoped=true"
import script from "./status-icon.vue?vue&type=script&lang=js"
export * from "./status-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f758a488",
  null
  
)

export default component.exports